
import { defineStore } from 'pinia'
import LangManager from '@/utils/langManager'
import { getAppInfo, removeAppInfo, setAppInfo } from '@/utils/auth';
import router from '@/router';


const SUFFIX_CLIENT_ID = {
  'ra': process.env.VUE_APP_RA_APPGUID,
  'm': process.env.VUE_APP_MEETING_APPGUID,
  // 'WF': process.env.VUE_APP_WORKFLOW_APPGUID,
  'w': process.env.VUE_APP_WORKFLOW_APPGUID,
};

export const appStore = defineStore({
  id: 'app',
  state: () => ({
    deviceCode: null,
    // appGuid: null,
    // language: null,

  }),
  getters: {
    // deviceCode: (state) => state.deviceCode,
    language: (state) => { return LangManager.i18n.global.locale },
    appGuid: (state) => {
    //   if (!state.appGuid)
      let appGuid = getAppInfo();
      if (!appGuid)
        // throw 'app id not found';
        router.push('/error');
      else
        return appGuid;
    //   return state.appGuid
    }
  },
  actions: {
    setLangurage(language){
      LangManager.setLanguage(language);
      // this.language = language;
    },
    setAppGuid(appGuid) {
      // this.appGuid = appGuid;
      setAppInfo(appGuid);
      // this.language = language;
    },
    setAppByRouter(routerPath) {
      const suffix = routerPath.replace('/', '').toLowerCase();
      // console.log('setAppByRouter', suffix);
      //  || appStore().appRoute;      
      // console.log(suffix, SUFFIX_CLIENT_ID[suffix])
      if (suffix && SUFFIX_CLIENT_ID[suffix]) {
        const appGuid = SUFFIX_CLIENT_ID[suffix]
        // console.log('appGuid', suffix);
        // this.appGuid = clientId;
        setAppInfo(appGuid);
        // console.log('clientId', this.clientId)
      }
      else {
        removeAppInfo();
        // throw { code: 40401, message: 'app not found' };
        router.push('/error');
      }
    }
  }
})
